import React from 'react';

const CustomDarkCheckbox = ({ checked, onChange }) => {
  return (
    <label className="inline-flex items-center cursor-pointer">
      {/* Checkbox مخفي */}
      <input 
        type="checkbox" 
        checked={checked} 
        onChange={onChange} 
        className="hidden peer"
      />

      {/* العنصر البصري للـ checkbox */}
      <span className="
        w-3 h-3 flex-shrink-0 border-2 border-gray-400 rounded-sm flex items-center justify-center
        peer-checked:border-blue-500 peer-checked:bg-blue-500
        dark:border-gray-500 dark:peer-checked:border-gray-400 dark:peer-checked:bg-gray-400
        transition-colors duration-300
      ">
        {/* علامة الصح تظهر لما checkbox متفعل */}
        {checked && (
          <svg 
            className="w-3 h-3 text-white dark:text-black" 
            fill="none" 
            stroke="currentColor" 
            strokeWidth="3" 
            viewBox="0 0 24 24"
          >
            <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
          </svg>
        )}
      </span>
    </label>
  );
};

export default CustomDarkCheckbox;
